<template>
  <div id="tlfoot">
    <div class="bg">
      <div class="bg-fore"></div>
      <div class="bg-midd"></div>
      <div class="bg-befo"></div>
    </div>
    <section class="footer-warp">
      <ul class="footer-list">
        <li @click="contactUs">
          <router-link to="/about#contact-us">
          <span>
            <img :src="pic2">
          </span>
          <p>联系我们</p>
          </router-link>
        </li>
        <li @click="openDia">
          <span>
            <img :src="pic3">
          </span>
          <p>免责声明</p>
        </li>
      </ul>
      <!--
      <ul class="link-box">
        <li v-for="(item, index) in linkList" :key="index"><a :href="item.link" target="_blank">{{item.name}}</a></li>
      </ul>
      -->
      <p class="permission">许可证号：京ICP备14018272号 备案编号：<a href="https://beian.miit.gov.cn" target="_blank">京ICP备12005671号</a> Copyright © 2025 图灵机器人 All rights Reserved</p>
    </section>
    <Modal
      v-model="modal1"
      title="免责声明"
      ok-text="知道了"
      cancel-text=""
      @on-ok="ok">
      <div class="modal-warp">
        <p class="tip-con"><strong>法律及免责声明</strong></p>
        <p class="tip-con">使用北京光年无限科技有限公司（以下简称“图灵机器人”或“本平台”）的产品和服务，<strong>表示您知悉并同意本法律声明的所有条款，且对使用本平台服务或产品的后果自行承担风险。</strong></p>
        <p class="tip-con"><strong>在您使用本平台服务或产品前，请您务必仔细阅读并透彻理解本声明，图灵机器人可能对本法律声明进行更新或补充，请定期查询本法律声明最新内容。</strong></p>
        <p class="tip-con"><<strong>一、权利归属声明</strong></p>
        <p class="tip-con">1、除非本公司另行声明外，由本公司运营的网站及客户端内所有产品、技术、软件、程序、数据及其他信息（包括文字、图标、图片、音频、视频、图表、版面设计、商标、商号、域名、代码等）以及“图灵机器人、TURING ROBOT、图宝”文字和/或LOGO创意IP相关内容的所有权利（包括但不限于著作权、商标权、专利权、商业秘密等相关权利）均属本公司所有。</p>
        <p class="tip-con"><strong>2、未经本公司书面许可，任何单位和/或个人不得以任何方式或理由对上述内容进行复制、下载、转载、摘编、修改、抓取、建立镜像或以其他任何方式展示、传播，否则均可能会侵犯本公司的权利，我们将会追究侵权者的法律责任。</strong></p>
        <p class="tip-con"><strong>二、使用限制</strong></p>
        <p class="tip-con">1、为维护本平台的正常运行秩序及效率，未经本公司许可，任何单位和/或个人不得自行、授权或协助第三方对本平台及其系统进行地址扫描、网络端口扫描、操作系统探测等扫描及/或探测，或包括通过机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像、上传、下载等方式擅自获取、使用本平台内的任何内容。</p>
        <p class="tip-con">2、在未经本平台许可，任何人亦不得通过本平台的账号自行或许可第三方使用用户账号等方式，获取账号体系内的任何资料、信息，特别是涉及商业秘密、个人信息在内的敏感类信息。</p>
        <p class="tip-con"><strong>三、网络生态建设</strong></p>
        <p class="tip-con">1、为了营造良好网络生态，保障公民、法人和其他组织的合法权益，维护国家安全和公共利益，我们将根据《中华人民共和国国家安全法》《中华人民共和国网络安全法》《互联网信息服务管理办法》等法律、行政法规，自觉践行社会主义核心价值观，营造清朗的网络空间，并开展的弘扬正能量、处置违法和不良信息等相关活动。</p>
        <p class="tip-con"><strong>2、任何人不得通过本平台制作、复制、上传、发布含有下列内容的违法信息：</strong></p>
        <p class="tip-con">（1）反对宪法所确定的基本原则的；</p>
        <p class="tip-con">（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
        <p class="tip-con">（3）损害国家荣誉和利益的；</p>
        <p class="tip-con">（4）歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；</p>
        <p class="tip-con">（5）宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；</p>
        <p class="tip-con">（6）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
        <p class="tip-con">（7）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
        <p class="tip-con">（8）散布谣言，扰乱经济秩序和社会秩序的；</p>
        <p class="tip-con">（9）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
        <p class="tip-con">（10）侮辱或者诽谤他人，侵害他人名誉、隐私和/或其他合法权益（包括但不限于第三方的知识产权等权利）的；</p>
        <p class="tip-con">（11）法律、行政法规禁止的其他内容。</p>
        <p class="tip-con"><strong>3、如任何单位或个人违反本声明第三条第2款内容或通过本平台发布、传送、传播、储存违反国家法律法规禁止的、侵犯本公司或其他任何第三方包括知识产权在内的合法权益的内容，或利用机器人进行诈骗、诱骗等违法行为导致他人的经济利益受到损失，由此所产生的一切法律责任均与本公司无关。同时，本公司有权进行独立判断并随时限制、冻结或终止实施前述行为的账号，如因此导致该等账号数据、经济或其他损失，由账号注册主体自行承担一切责任。如因账号注册主体实施违反国家法律法规的或本声明所禁止的行为导致本公司及其平台遭受损失的，本公司保留追究违规者法律责任的权利。</strong></p>
        <p class="tip-con">4、我们尊重知识产权，反对并打击侵犯知识产权的行为，任何单位或个人认为本平台展示、使用的内容可能涉嫌侵犯其合法权益，可及时向本公司反馈，并提供身份证明、权属证明及详细侵权情况证明，本公司将尽快核实并及时处理。</p>
        <p class="tip-con"><strong>四、责任限制</strong></p>
        <p class="tip-con">1、鉴于本平台及产品服务需要网络支撑，本公司有权对提供网络服务的平台或相关设备进行部分或全部的维护、更新、切换，如因此类情况造成的网络服务在一定时间内出现中断，本公司无需通知用户，也无需承担任何责任。</p>
        <p class="tip-con">2、如本平台的系统发生故障影响到所提供服务的正常运行，本平台将及时采取修复措施。但用户因此而产生的经济损失，本公司不承担责任。此外，本平台保留不经事先通知进行维修保养、升级或其他目的暂停本服务任何部分的权利。</p>
        <p class="tip-con">3、本平台依照法律规定履行基础保障义务，但对于下述原因导致的本平台服务存在问题的，本平台并不承担相应的责任：</p>
        <p class="tip-con">(1)不可抗力，包括但不限于政府行为、自然灾害、战争、罢工、动乱等；</p>
        <p class="tip-con">(2)基础电信运营商网络服务器网络出现电力中断或网络故障、电信/电力部门对电信网络/电力资源进行安装、改造、维护等；</p>
        <p class="tip-con">(3)网络安全事故，如计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</p>
        <p class="tip-con">(4)用户操作不当或用户的设备、系统、硬件和通信线路出现故。</p>
        <p class="tip-con">4、任何通过使用本平台而链接、跳转到的第三方网页、程序均系他人制作或提供，您可能从该第三方网页上获得资讯及享用服务，除法律法规另有规定的，本平台对其合法性概不负责，亦不承担任何法律责任。</p>
        <p class="tip-con"><strong>五、法律适用及争议解决</strong></p>
        <p class="tip-con">1、本法律声明的解释、履行均适用中华人民共和国法律法规，因解释、履行本法律声明或您本平台服务产品而导致的争议，将同意接受本公司所在地人民法院的管辖。</p>
      </div>
    </Modal>
  </div>
</template>
<script>
import img1 from '@/assets/images/fico1.png'
import img2 from '@/assets/images/fico2.png'
import img3 from '@/assets/images/fico3.png'
export default {
  name: 'TlFoot',
  data () {
    return {
      pic1: img1,
      pic2: img2,
      pic3: img3,
      linkList: [
        {
          name: '图灵AI开放平台',
          link: 'http://biz.turingos.cn/home'
        },
        {
          name: 'APICloud',
          link: 'https://www.apicloud.com/'
        },
        {
          name: '容联云通讯',
          link: 'http://www.yuntongxun.com/'
        },
        {
          name: '融云即时通讯云',
          link: 'http://www.rongcloud.cn/'
        },
        {
          name: 'PHPChina',
          link: 'http://www.phpchina.com/'
        },
        {
          name: '京东万象',
          link: 'https://wx.jdcloud.com/'
        },
        {
          name: '极客学院',
          link: 'http://www.jikexueyuan.com/'
        }
      ],
      modal1: false,
      tapBl: false
    }
  },
  mounted () {
    document.querySelector('.link-box').addEventListener('tap', this.tap, false)
  },
  beforeDestroy () {
    if (this.tapBl) {
      document.querySelector('.link-box').removeEventListener('tap', this.tap, false)
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'Chat') {
        this.$store.dispatch('setFootbar', false)
      }
    }
  },
  methods: {
    tap (index, event) {
      console.log(event._constructed)
      if (event._constructed) {
        return
      }
      this.tapBl = true
      window.open(index.target.href, '_blank')
    },
    openDia () {
      this.modal1 = true
      if (window._czc) {
        window._czc.push(['_trackEvent', '按钮', '点击', '免责声明', '1', '免责声明'])
      }
    },
    contactUs () {
      if (window._czc) {
        window._czc.push(['_trackEvent', '按钮', '点击', '联系我们', '1', '联系我们'])
      }
    },
    ok () {},
    cancel () {}
  }
}
</script>
<style lang="less" scoped>
  #tlfoot {
    height: 330px;
    width: 100%;
    background: url(../assets/images/footer.png) no-repeat;
    background-size: 100% 100%;
    position: relative;
    .bg {
      position: absolute;
      top:0;
      left: 0;
      right: 0;
      bottom: 0;
      height: 330px;
      opacity: 0.4;
      div {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
      }
      .bg-fore {
        background:url('../assets/images/foreground.png')repeat 35% 0%;
        animation: star-move 100s linear infinite;
        z-index: 2;
      }
      .bg-midd {
        background:url('../assets/images/midground.png')repeat 20% 0%;
        animation: star-move 150s linear infinite;
        z-index: 1;
      }
      .bg-befo {
        background:black url('../assets/images/background.png')repeat-x 5% 0%;
        animation: star-move 250s linear infinite;
      }
    }
    @keyframes star-move {
      from {
        background-position:0% 0%
      }
      to {
        background-position: 600% 0%
      }
    }
    .footer-warp {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 848px;
      height: 300px;
      margin-top:-150px;
      margin-left: -424px;
      text-align: center;
      z-index: 3;
      .footer-list {
        padding-top: 90px;
        margin:0 auto 66px;
        width: 434px;
        height: 177px;
        li {
          float:left;
          width: 95px;
          height: 87px;
          cursor: pointer;
          a {
            display: inline-block;
            width: 95px;
            height: 87px;
          }
          p {
            width: 100%;
            margin-top: 17px;
            font-size: 22px;
            line-height: 30px;
            color:#fff;
          }
        }
        li:nth-of-type(1) {
          margin-right:244px;
        }
      }
      .link-box {
        width: 100%;
        font-size: 14px;
        line-height: 18px;
        padding-bottom: 24px;
        text-align: center;
        opacity: 0.8;
        li {
          display: inline-block;
          margin-right: 20px;
          a {
            color:#fff;
            padding-bottom: 2px;
            border-bottom: 1px solid #fff;
          }
        }
      }
      .permission {
        text-align: center;
        height:20px;
        font-size: 13px;
        line-height: 1;
        color: rgba(255, 255, 255, 0.3);
      }
    }
  }
  .ivu-modal-body {
    .modal-warp {
      max-height: 580px;
      overflow: auto;
      .tip-con {
        text-indent: 24px;
        margin-bottom: 4px;
      }
    }
    .modal-warp::-webkit-scrollbar {display:none}
  }
  @media (max-width: 1000px) {
    #tlfoot {
      height: 330px;
      width: 100%;
      background: url(../assets/images/footer.png) no-repeat;
      background-size: 100% 100%;
      position: relative;
      .bg {
        position: absolute;
        top:0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 330px;
        div {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
        }
        .bg-fore {
          background:url('../assets/images/foreground.png')repeat 35% 0%;
          animation: star-move 100s linear infinite;
          z-index: 2;
        }
        .bg-midd {
          background:url('../assets/images/midground.png')repeat 20% 0%;
          animation: star-move 150s linear infinite;
          z-index: 1;
        }
        .bg-befo {
          background:black url('../assets/images/background.png')repeat-x 5% 0%;
          animation: star-move 250s linear infinite;
        }
      }
      @keyframes star-move {
        from {
          background-position:0% 0%
        }
        to {
          background-position: 600% 0%
        }
      }
      .footer-warp {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 848px;
        height: 300px;
        margin-top:-150px;
        margin-left: -424px;
        text-align: center;
        z-index: 3;
        .footer-list {
          padding-top: 90px;
          margin:0 auto 66px;
          width: 434px;
          height: 177px;
          li {
            float:left;
            width: 95px;
            height: 87px;
            cursor: pointer;
            a {
              display: inline-block;
              width: 95px;
              height: 87px;
            }
            p {
              width: 100%;
              margin-top: 10px;
              font-size: 18px;
              line-height: 30px;
              color:#fff;
            }
          }
          li:nth-of-type(1) {
            margin-right:244px;
          }
        }
        .link-box {
          width: 100%;
          font-size: 14px;
          line-height: 18px;
          padding-bottom: 24px;
          text-align: center;
          opacity: 0.8;
          li {
            display: inline-block;
            margin-right: 20px;
            a {
              color:#fff;
              padding-bottom: 2px;
              border-bottom: 1px solid #fff;
            }
          }
        }
        .permission {
          text-align: center;
          height:20px;
          font-size: 13px;
          line-height: 1;
          color: rgba(255, 255, 255, 0.3);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue